import "./App.css";
import SurveyData from "./survey.json";
import { CustomSurvey } from "./components/CustomSurvey";

function App() {
  return (
    <div className="App">
      <CustomSurvey surveyData={SurveyData} />
      <div id="survey-result"></div>
    </div>
  );
}

export default App;
